import React from 'react';
import { Modal } from 'antd-mobile';

const ModalPopup = ({
  isVisible,
  onClose,
  title,
  content,
  allowConfirm = true,
  isInsurance,
}) => {
  let modalActions = [];

  if (!isVisible) return null;

  // 根據 allowConfirm 和 isInsurance 來決定顯示的按鈕
  if (allowConfirm) {
    if (isInsurance) {
      modalActions = [
        {
          key: 'goToInsurance',
          text: '前往出險平台',
          onClick: () => {
            window.location.href =
              'https://www.qccp.tw/LEXUS/IDP001/IDP001/?p=qlB71AQe2XyNrHGpo9ELU6%2buBGX%2b0J5PrS2ZF0mVZVp%2f5IErQSN4yxctWCYOebTh';
          },
        },
      ];
    } else {
      modalActions = [
        {
          key: 'confirm',
          text: '確認',
          onClick: onClose,
        },
      ];
    }
  }

  return (
    <Modal
      visible={isVisible}
      title={title}
      content={content}
      closeOnAction
      actions={modalActions}
    />
  );
};

export default ModalPopup;
